import { useNavigate } from 'react-router-dom';
import { useCall } from '../customer-call-sdk';

export default function useCustomerCallRedirect() {
    const navigate = useNavigate();
    const { connected, isJoining, isConnecting } = useCall();

    if (connected) {
        navigate('/room');
        return 'Redirecting to Room';
    }

    if (isJoining || isConnecting) {
        navigate('/home');
        return 'Redirecting to Landing Page';
    }

    return 'No Redirect';
}
